import Cookies from "js-cookie";

// Guest carts live in localStorage: a cookie holds only about 4KB, and past that
// the browser silently keeps the old value, so a few items disappeared on refresh.
const GUEST_CART_KEY = "guest_cart";
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

export const saveGuestCart = (cart: unknown): void => {
  try {
    localStorage.setItem(GUEST_CART_KEY, JSON.stringify({ savedAt: Date.now(), cart }));
  } catch (err) {
    console.error("❌ Failed to save guest cart:", err);
  }
};

export const clearGuestCart = (): void => {
  try {
    localStorage.removeItem(GUEST_CART_KEY);
  } catch {
    /* storage unavailable */
  }
  Cookies.remove(GUEST_CART_KEY, { path: "/" });
};

export const readGuestCart = (): any | null => {
  try {
    const stored = localStorage.getItem(GUEST_CART_KEY);
    if (stored) {
      const { savedAt, cart } = JSON.parse(stored);
      if (Date.now() - savedAt <= MAX_AGE_MS) return cart ?? null;
      clearGuestCart();
      return null;
    }
    // Carts saved before the move to localStorage
    const cookie = Cookies.get(GUEST_CART_KEY);
    if (!cookie) return null;
    const cart = JSON.parse(cookie);
    Cookies.remove(GUEST_CART_KEY, { path: "/" });
    if (!Array.isArray(cart?.items)) return null;
    saveGuestCart(cart);
    return cart;
  } catch (err) {
    console.error("❌ Failed to read guest cart:", err);
    return null;
  }
};
